import {
    IActivation, IActivationCase, IActivationComment, IActivationCreate, IActivationType, IBrandWithChildren, IDashboard, IEntity,
    IEntityType, IHashtag, IInfluencer, IKeyword, IMarketWithChildren, IRole, IUser, IMarket, IBrandQualityWithChildren, IActivationUser, IActivationUserPermission, IPrAffiliate,
} from "@/models";
import { IUploadFile } from "@/models/IUploadFile";

interface IAppState {
    activationType: IActivationType[];
    activationCase: IActivationCase[];
    activationCreate: IActivationCreate[];
    markets: IMarketWithChildren[];
    dashboard: IDashboard[];
    activations: IActivation[];
    keywords: IKeyword[];
    hashtags: IHashtag[];
    brands: IBrandWithChildren[];
    prAffiliates: IPrAffiliate[];
    brandsQuality: IBrandQualityWithChildren[];
    files: IUploadFile[];
    users: IUser[];
    entities: IEntity[];
    entityTypes: IEntityType[];
    roles: IRole[];
    unauthorizeRoles: IRole[];
    currentActivation: IActivation;
    activationComments: IActivationComment[];
    influencersTemplate: Blob;
    influencers: Blob;
    activationUsers: IActivationUser[];
    upsertActivationUser: IActivationUser[];
}

const initialState: IAppState = {
    activationType: [],
    activationCase: [],
    activationCreate: [],
    markets: [],
    dashboard: [],
    users: [],
    entities: [],
    entityTypes: [],
    roles: [],
    unauthorizeRoles: [],
    activations: [],
    keywords: [],
    hashtags: [],
    brands: [],
    prAffiliates: [],
    brandsQuality: [],
    files: [],
    currentActivation: null,
    activationComments: [],
    influencersTemplate: null,
    influencers: null,
    activationUsers: [],
    upsertActivationUser: [],
};

export { IAppState, initialState };

